import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import InValidLottie from "../Lottie-Components/InValidLottie";
import { setMyTestsCache } from "../../configs/cache";
import LoadingLottie from "../Lottie-Components/LoadingLottie";
import { PAGE_LIMIT } from "../../constants/text_constants";
import CourseCard from "../Card-Component/CourseCard";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { useNavigate, useLocation } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import IntegratedPagination from "../Pagination/IntegratedPagination";
import saveAuthToken from "../../utils/saveAuthToken";

const MyTestsList = () => {
  const userAuthenticated = sessionStorage.getItem("authenticated") === "1";
  const [currentPage, setCurrentPage] = useState(0);
  const [myTests, setMyTests] = useState(0);
  const authToken = sessionStorage.getItem("token");
  const cache = useSelector((store) => store.cache.myTestsCache);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchMyTests = async (retries = 6) => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_MY_TESTS_DATA +
          PAGE_LIMIT +
          `/${currentPage}`,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchMyTests(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setMyTests(json?.data);
      setTotalPages(Math.ceil(json?.data?.total / PAGE_LIMIT));
      dispatch(setMyTestsCache([json?.data, currentPage]));
      saveAuthToken(json?.data?.token);
    } catch (err) {
      console.error("Error fetchMyTests", err);
    }
  };

    // Reset state when the route (tab) changes
  useEffect(() => {
    setMyTests(null);
    setCurrentPage(0);
    setTotalPages(0);
  }, [location.pathname]);
  useEffect(() => {
    if (userAuthenticated) {
      if (cache[currentPage]) {
        setMyTests(cache[currentPage]);
        setTotalPages(Math.ceil(cache[currentPage]?.total / PAGE_LIMIT));
      } else {
        fetchMyTests();
      }
    }
  }, [currentPage, cache, userAuthenticated, location.pathname]);

  // user has not signed in
  if (!userAuthenticated) {
    return (
      <InValidLottie text={"You Need to sign in to see your Test Packages"} />
    );
  }

  // loading animation
  if (!myTests) {
    return <LoadingLottie />;
  }

  if (myTests?.test_packages.length === 0) {
    return <InValidLottie text={"You have not purchased any Test Packages"} />;
  }

  return (
    <div>
      <div className=" grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-8 gap-4">
        {myTests?.test_packages.map((ele, i) => (
          <CourseCard
            key={i}
            name={ele?.name}
            offer_price={ele?.offer_price}
            offer_discount={ele?.offer_discount}
            price={ele?.price}
            course_banner={ele?.banner_url}
            title_1={"Duration"}
            value_1={ele?.duration}
            title_2={"Start Date"}
            value_2={ele?.starts_on}
            title_3={"End Date"}
            value_3={ele?.ends_on}
            title_4={"Validity"}
            value_4={ele?.validity}
            rating={ele?.rating}
            faculty_name={ele?.faculty_name}
            thumbnail={ele?.thumbnail}
            description={ele?.description}
            totalRating={ele?.total_rating}
            id={ele?.id}
            exploreMoreLink={UNPROTECTED_ROUTES?.testDetails}
            showPrice={false}
            showBuyNow={false}
            showExploreMore={false}
            showView={true}
          />
        ))}
      </div>
      <div className="my-[5rem]">
        <IntegratedPagination
          currentPage={currentPage + 1}
          totalPages={totalPages}
          setCurrentPage={(page) => setCurrentPage(page - 1)}
        />
      </div>
    </div>
  );
};

export default MyTestsList;
